import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { ACTIVITIES_PATH, ROOMS_PATH, routeTo } from "@/lib/site";
import { Reveal } from "../Reveal";

const CARDS = [
  {
    title: "Events and Group Stays",
    body: "Amigo Inn & RV Park is a welcoming place for family reunions, birthday celebrations, fishing groups, holiday gatherings, business meetings, and other group stays.",
    cta: "Explore Activities",
    href: ACTIVITIES_PATH,
  },
  {
    title: "Rooms and RV Sites",
    body: "Explore full-hookup RV sites, cabins, motel rooms, efficiency accommodations, tent camping, and extended-stay options.",
    cta: "View Rooms and Parks",
    href: ROOMS_PATH,
  },
] as const;

export function UsefulInfo() {
  return (
    <section className="bg-surface py-24 sm:py-28" aria-labelledby="useful-info-title">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <Reveal>
          <p className="eyebrow text-clay">Helpful Links</p>
          <h2
            id="useful-info-title"
            className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.7rem]"
          >
            Useful Information
          </h2>
        </Reveal>

        <ul className="mt-12 grid gap-8 lg:grid-cols-2">
          {CARDS.map((card, i) => (
            <Reveal as="li" key={card.title} delay={i * 0.08}>
              <article className="flex h-full flex-col border-t border-sand pt-8">
                <h3 className="font-display text-2xl text-forest-deep sm:text-[1.75rem]">
                  {card.title}
                </h3>
                <p className="mt-4 flex-1 text-base leading-relaxed text-muted-foreground">
                  {card.body}
                </p>
                <Link
                  to={routeTo(card.href)}
                  className="link-underline mt-6 inline-flex text-sm font-semibold text-forest"
                >
                  {card.cta} <ArrowRight className="size-4" aria-hidden="true" />
                </Link>
              </article>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
